module.exports = __webpack_public_path__ + "static/media/boat-img-40.7426a268.jpg";